import { render, staticRenderFns } from "./SignUpGroup.vue?vue&type=template&id=c2f61020&lang=html"
import script from "./SignUpGroup.vue?vue&type=script&lang=js"
export * from "./SignUpGroup.vue?vue&type=script&lang=js"
import style0 from "./SignUpGroup.vue?vue&type=style&index=0&id=c2f61020&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports